import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _commentsWidget = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _createCommentsWidgetRequest = { commentsWidget: '_commentsWidget' };
var _createCommentsWidgetResponse = { commentsWidget: '_commentsWidget' };
var _deleteCommentsWidgetRequest = {};
var _deleteCommentsWidgetResponse = {};
var _getCommentsWidgetRequest = {};
var _getCommentsWidgetResponse = { commentsWidget: '_commentsWidget' };
var _queryCommentsWidgetRequest = {};
var _queryCommentsWidgetResourcesRequest = {};
var _queryCommentsWidgetResourcesResponse = {};
var _queryCommentsWidgetResponse = { commentsWidgets: '_commentsWidget' };
var _registerCommentsWidgetRequest = {};
var _registerCommentsWidgetResponse = { commentsWidget: '_commentsWidget' };
var _updateCommentsWidgetRequest = {
    mask: 'google.protobuf.FieldMask',
    commentsWidget: '_commentsWidget',
};
var _updateCommentsWidgetResponse = { commentsWidget: '_commentsWidget' };
function resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/comments-widget-registry',
                destPath: '/v1/comments/widgets',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/comments-widget-registry/v1/comments/widgets',
                destPath: '/v1/comments/widgets',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/comments-widget-registry/v1/comments/widgets',
                destPath: '/v1/comments/widgets',
            },
            {
                srcPath: '/_api/comments/widgets/v1',
                destPath: '/v1/comments/widgets',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/comments-widget-registry/v1/comments/widgets',
                destPath: '/v1/comments/widgets',
            },
            {
                srcPath: '/_api/comments/widgets/v1',
                destPath: '/v1/comments/widgets',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/comments-widget-registry/v1/comments/widgets',
                destPath: '/v1/comments/widgets',
            },
            {
                srcPath: '/_api/comments/widgets/v1',
                destPath: '/v1/comments/widgets',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/comments-widget-registry/v1/comments/widgets',
                destPath: '/v1/comments/widgets',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/comments-widget-registry/v1/comments/widgets',
                destPath: '/v1/comments/widgets',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/api/v1/comments/widgets',
                destPath: '/v1/comments/widgets',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/comments-widget-registry',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Registers CommentsWidget. Whenever a widget is loaded for the first time or its resourceId changes, it saves the new resource information about the widget */
export function registerCommentsWidget(payload) {
    var _a = serializer(_registerCommentsWidgetRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_registerCommentsWidgetResponse, {
        _commentsWidget: _commentsWidget,
    }).fromJSON;
    function __registerCommentsWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.categories.v1.comments_widget',
            method: 'POST',
            methodFqn: 'wix.comments.categories.v1.CommentsWidgetRegistry.RegisterCommentsWidget',
            url: resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl({
                protoPath: '/v1/comments/widgets/register',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __registerCommentsWidget.fromReq = fromReq;
    __registerCommentsWidget.__isAmbassador = true;
    return __registerCommentsWidget;
}
/** Returns all registered widget resource ids contained in metaSite */
export function queryCommentsWidgetResources(payload) {
    var _a = serializer(_queryCommentsWidgetResourcesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCommentsWidgetResourcesResponse, {}).fromJSON;
    function __queryCommentsWidgetResources(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.categories.v1.comments_widget',
            method: 'POST',
            methodFqn: 'wix.comments.categories.v1.CommentsWidgetRegistry.QueryCommentsWidgetResources',
            url: resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl({
                protoPath: '/v1/comments/widgets/resources/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCommentsWidgetResources.fromReq = fromReq;
    __queryCommentsWidgetResources.__isAmbassador = true;
    return __queryCommentsWidgetResources;
}
/** Creates a new CommentsWidget */
export function createCommentsWidget(payload) {
    var _a = serializer(_createCommentsWidgetRequest, { _commentsWidget: _commentsWidget }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCommentsWidgetResponse, {
        _commentsWidget: _commentsWidget,
    }).fromJSON;
    function __createCommentsWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.categories.v1.comments_widget',
            method: 'POST',
            methodFqn: 'wix.comments.categories.v1.CommentsWidgetRegistry.CreateCommentsWidget',
            url: resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl({
                protoPath: '/v1/comments/widgets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCommentsWidget.fromReq = fromReq;
    __createCommentsWidget.__isAmbassador = true;
    return __createCommentsWidget;
}
/** Get a CommentsWidget by id */
export function getCommentsWidget(payload) {
    var _a = serializer(_getCommentsWidgetRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCommentsWidgetResponse, {
        _commentsWidget: _commentsWidget,
    }).fromJSON;
    function __getCommentsWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.categories.v1.comments_widget',
            method: 'GET',
            methodFqn: 'wix.comments.categories.v1.CommentsWidgetRegistry.GetCommentsWidget',
            url: resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl({
                protoPath: '/v1/comments/widgets/{commentsWidgetId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCommentsWidget.fromReq = fromReq;
    __getCommentsWidget.__isAmbassador = true;
    return __getCommentsWidget;
}
/**
 * Update CommentsWidget, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateCommentsWidget(payload) {
    var _a = serializer(_updateCommentsWidgetRequest, { _commentsWidget: _commentsWidget }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCommentsWidgetResponse, {
        _commentsWidget: _commentsWidget,
    }).fromJSON;
    function __updateCommentsWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.categories.v1.comments_widget',
            method: 'PATCH',
            methodFqn: 'wix.comments.categories.v1.CommentsWidgetRegistry.UpdateCommentsWidget',
            url: resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl({
                protoPath: '/v1/comments/widgets/{commentsWidget.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCommentsWidget.fromReq = fromReq;
    __updateCommentsWidget.__isAmbassador = true;
    return __updateCommentsWidget;
}
/** Delete a CommentsWidget */
export function deleteCommentsWidget(payload) {
    var _a = serializer(_deleteCommentsWidgetRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCommentsWidgetResponse, {}).fromJSON;
    function __deleteCommentsWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.categories.v1.comments_widget',
            method: 'DELETE',
            methodFqn: 'wix.comments.categories.v1.CommentsWidgetRegistry.DeleteCommentsWidget',
            url: resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl({
                protoPath: '/v1/comments/widgets/{commentsWidgetId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCommentsWidget.fromReq = fromReq;
    __deleteCommentsWidget.__isAmbassador = true;
    return __deleteCommentsWidget;
}
/** Query CommentsWidgets using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryCommentsWidget(payload) {
    var _a = serializer(_queryCommentsWidgetRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCommentsWidgetResponse, {
        _commentsWidget: _commentsWidget,
    }).fromJSON;
    function __queryCommentsWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.categories.v1.comments_widget',
            method: 'POST',
            methodFqn: 'wix.comments.categories.v1.CommentsWidgetRegistry.QueryCommentsWidget',
            url: resolveWixCommentsCategoriesV1CommentsWidgetRegistryUrl({
                protoPath: '/v1/comments/widgets/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCommentsWidget.fromReq = fromReq;
    __queryCommentsWidget.__isAmbassador = true;
    return __queryCommentsWidget;
}
//# sourceMappingURL=http.impl.js.map